import { Features } from '@alsid/common'
import {
  rbacCapabilityCheckAllOf,
  rbacCapabilityCheckAnyOf
} from '@libs/rbac/functions'
import {
  accessByFeatureFlag,
  accessByFeatureFlagDisabled,
  readSecurityEngine
} from '@libs/rbac/permissions'
import { canAccessToWeaknesses } from '../Weaknesses/permissions'

export const canAccessToExposureCenter = rbacCapabilityCheckAllOf(
  accessByFeatureFlag(Features.EXPOSURE_CENTER_REDESIGN)(),
  canAccessToWeaknesses
)

export const canAccessToSecurityEngine = rbacCapabilityCheckAnyOf(
  rbacCapabilityCheckAllOf(
    accessByFeatureFlagDisabled(Features.EXPOSURE_CENTER_REDESIGN)(),
    readSecurityEngine()
  ),
  canAccessToExposureCenter
)

export const canAccessToSecurityEngineMilestone3 = rbacCapabilityCheckAllOf(
  canAccessToSecurityEngine,
  accessByFeatureFlag(Features.KAPTEYN_SECURITY_ENGINE_MILESTONE_3)()
)

export const canAccessToSecurityEngineMilestone4 = rbacCapabilityCheckAllOf(
  canAccessToSecurityEngineMilestone3,
  accessByFeatureFlag(Features.KAPTEYN_SECURITY_ENGINE_MILESTONE_4)()
)

export const canAccessToSecurityEngineMilestone5 = rbacCapabilityCheckAllOf(
  canAccessToSecurityEngineMilestone4,
  accessByFeatureFlag(Features.KAPTEYN_SECURITY_ENGINE_MILESTONE_5)()
)

export const canAccessToSecurityEngineMilestone6 = rbacCapabilityCheckAllOf(
  canAccessToSecurityEngineMilestone5,
  accessByFeatureFlag(Features.KAPTEYN_SECURITY_ENGINE_MILESTONE_6)()
)
